import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart'
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock'
import { faThumbsUp } from "@fortawesome/pro-solid-svg-icons/faThumbsUp";
import { faGlobe } from "@fortawesome/pro-solid-svg-icons/faGlobe";
import { faUserLock } from "@fortawesome/pro-solid-svg-icons/faUserLock";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { ListType } from "models/ApiEnums";

export function translateName(listType: ListType): string {
    switch (listType) {
        case ListType.Favorite: return "Favoritos";
        case ListType.SeeLater: return "Ver mais tarde";
        case ListType.Liked: return "Gostei";
    }
    return null;
}

export function getIcon(listType: ListType, isPublic: boolean): IconDefinition {
    switch (listType) {
        case ListType.Favorite: return faHeart;
        case ListType.SeeLater: return faClock;
        case ListType.Liked: return faThumbsUp;
    }

    return (isPublic) ? faGlobe : faUserLock;
}
